import {isNotNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {buildArray} from 'shared/web';

import {type OfferAlternative} from '../types/OfferAlternative';
import {getAlternativeLabel} from './getAlternativeLabel';

const t = (key: string, fallback: string) => i18n.t(key, {defaultValue: fallback});

/**
 * A new source resets the alternative's negotiated terms on the backend (discount, notes, custom
 * name); its upsell lines are carried. Returns what the seller is about to lose, or null when
 * nothing is lost.
 */
export const getSourceChangeWarning = (alternative: OfferAlternative) => {
  const {terms} = alternative;
  const lostTerms = buildArray<string>()
    .when(isNotNil(terms.discount), t('entity.offerAlternative.lostTerms.discount', 'discount'))
    .when(
      isNotNilOrEmpty(terms.customerNote),
      t('entity.offerAlternative.lostTerms.customerNote', 'customer note')
    )
    .when(
      isNotNilOrEmpty(terms.deliveryNote),
      t('entity.offerAlternative.lostTerms.deliveryNote', 'delivery information')
    )
    .when(
      isNotNilOrEmpty(alternative.name),
      t('entity.offerAlternative.lostTerms.name', 'name shown to the customer')
    );

  if (lostTerms.length === 0) {
    return null;
  }

  return i18n.t('entity.offerAlternative.changeSourceConfirm', {
    defaultValue: 'Changing the vehicle of {label} removes its {terms}.',
    label: getAlternativeLabel(alternative),
    terms: new Intl.ListFormat(i18n.language, {type: 'conjunction'}).format(lostTerms),
  });
};
